import { currentLocale } from "../i18n/locale-provider";

export const removeLocaleFromSlug = (slug, locale) => {
  locale = locale || currentLocale;
  return slug.replace(`-${locale}`, "");
};
